import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { HashRouter, BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { selectTheme } from './redux/selectors';
import { Welcome, TopBar, Calculator, Paint, APIFetcher, BottomBar } from './modules';
import { MainFrameContainer } from './styled';
const App = () => {
    const { theme } = useSelector(selectTheme);
    const Router = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
        ? BrowserRouter
        : HashRouter;
    return (_jsx(ThemeProvider, { theme: theme, children: _jsxs(Router, { children: [_jsx(TopBar, {}), _jsx(MainFrameContainer, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "", element: _jsx(Navigate, { to: "/welcome" }) }), _jsx(Route, { path: "/welcome", element: _jsx(Welcome, {}) }), _jsx(Route, { path: "/apifetcher", element: _jsx(APIFetcher, {}) }), _jsx(Route, { path: "/calculator", element: _jsx(Calculator, {}) }), _jsx(Route, { path: "/paint", element: _jsx(Paint, {}) })] }) }), _jsx(BottomBar, {})] }) }));
};
export default App;
